'use client';

import BadRoute from '@/core/pages/bad-route';

export default function NotFound() {
  return <BadRoute />;
}
